// src/pages/Diagnostics.jsx
import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import api from "../services/api";

export default function Diagnostics() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState(null);
  const [error, setError] = useState("");

  const fetchDiagnostics = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await api.get("/diagnostics");
      setItems(res.data || []);
    } catch (err) {
      console.error("Diagnostics load error:", err);
      setError("Could not load diagnostics");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchDiagnostics(); }, []);

  return (
    <Layout>
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-bold mb-6 text-indigo-600">Device Diagnostics</h1>

        {error && <div className="mb-4 p-3 bg-red-50 text-red-700 rounded">{error}</div>}

        <div className="space-y-4">
          {items.map(it => (
            <div key={it.id} className="bg-white p-4 rounded shadow">
              <div className="flex justify-between items-center">
                <div>
                  <div className="text-lg font-semibold">{it.user_id || "Unknown"}</div>
                  <div className="text-sm text-gray-500">{new Date(it.created_at).toLocaleString()}</div>
                </div>
                <div>
                  <button
                    onClick={() => setExpanded(expanded === it.id ? null : it.id)}
                    className="text-indigo-600 hover:underline"
                  >
                    {expanded === it.id ? "Hide" : "View"}
                  </button>
                </div>
              </div>

              {expanded === it.id && (
                <pre className="mt-3 bg-gray-50 p-3 rounded text-xs overflow-auto text-black">
                  {JSON.stringify(it, null, 2)}
                </pre>
              )}
            </div>
          ))}

          {items.length === 0 && <div className="p-4 bg-white rounded shadow text-gray-500">No diagnostics found.</div>}
        </div>

        {loading && <div className="mt-4 text-center text-gray-500">Loading…</div>}
      </div>
    </Layout>
  );
}
